import Player from "video.js/dist/types/player";

import { getVideoJsComponent } from "./utils";

/**
 * HACK: theoplayerの読み込みが完了する前にこのモジュールがインポートされると、
 * getVideoJsComponent内でwindow.THEOplayerがundefinedとなりエラーになるため、
 * 関数としてエクスポートし、必要なときに呼び出す形にする。
 * 本当はnpm管理のtheoplayerパッケージを使いたいが、検証が不十分なため現状はこの方法で対応。
 */
export const getSpacingElement = () => {
  const VideoJSComponent = getVideoJsComponent("Component");

  class SpacingElement extends VideoJSComponent {
    constructor(player: Player, options = {}) {
      super(player, options);
    }

    createEl() {
      const el = super.createEl("div", {
        className: "vjs-custom-spacing",
      });
      return el;
    }
  }

  return SpacingElement;
};
